import { createPortal } from "react-dom";
import { AlertTriangle, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { Card, CardBody, CardHeader } from "@/components/ui/Card";
import { hubModalOverlayProps } from "@/components/ui/HubModalOverlay";

export function InboundArrivalPackageCancelModal({
  open,
  packageNo,
  scanLabel,
  confirming = false,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  packageNo: number;
  scanLabel: string;
  confirming?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}): JSX.Element | null {
  if (!open) return null;

  return createPortal(
    <div {...hubModalOverlayProps(true)}>
      <Card className="mt-6 w-full max-w-lg shadow-xl">
        <CardHeader className="border-b border-slate-200">
          <h2 className="flex items-center gap-2 text-lg font-semibold text-slate-900">
            <AlertTriangle className="h-5 w-5 shrink-0 text-amber-600" aria-hidden />
            Cancel crate label?
          </h2>
          <p className="mt-1 text-sm text-slate-600">
            Crate {packageNo} will be voided and removed from this shipment. The printed tag should be discarded.
            Receiving scans of this tag will fail after cancel.
          </p>
        </CardHeader>
        <CardBody className="space-y-4">
          {scanLabel.trim() !== "" ? (
            <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2">
              <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">Scan id on label</p>
              <p className="mt-1 font-mono text-base leading-relaxed text-slate-900 whitespace-pre-wrap">{scanLabel}</p>
            </div>
          ) : null}
          <div className="flex flex-wrap justify-end gap-2">
            <Button type="button" variant="secondary" disabled={confirming} onClick={onCancel}>
              Keep crate
            </Button>
            <Button type="button" variant="primary" disabled={confirming} onClick={onConfirm}>
              {confirming ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : null}
              Cancel crate
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>,
    document.body,
  );
}
